// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x5L0L","option":"styles_option__k5Idh","active":"styles_active__1YHjA"};